import { ReactNode, useState } from 'react';
import { PersonContext } from '../../lib/helpers/personContext';
import { PersonData } from '../../model/types';
import { TSearchMode } from '../../lib/types';

export const PersonBookProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [person, setPerson] = useState<PersonData | null>(null);
	const [isOpenPersonBook, setOpenPersonBook] = useState(false);
	const [searchMode, setSearchMode] = useState<TSearchMode>('searchByName');

	return (
		<PersonContext.Provider
			value={{
				person,
				searchMode,
				isOpenPersonBook,
				setPerson,
				setOpenPersonBook,
				setSearchMode,
			}}
		>
			{children}
		</PersonContext.Provider>
	);
};
